import { PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../constants.js";
import { actions as extraProductActions } from "../ancillaries/store/extraProducts/actions.js";
export const preOptedAncillariesFromScreenQueryToStore = (flight, dispatch) => {
    const screenQuery = new URLSearchParams(location.search);
    const ancillaryToQueryParamName = {
        flexibleTicket: [
            PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket,
            PRE_OPTED_ANCILLARIES_QUERY_PARAMS.checkoutFlexibleTicket
        ],
        checkedInBaggage: [PRE_OPTED_ANCILLARIES_QUERY_PARAMS.checkedInBaggage],
        cancelForAnyReason: [PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason]
    };
    Object.keys(ancillaryToQueryParamName).forEach((ancillary) => {
        const paramNames = ancillaryToQueryParamName[ancillary];
        if (paramNames.some((paramName) => screenQuery.has(paramName))) {
            const isAvailable = flight.ancillaries && flight.ancillaries[ancillary];
            if (isAvailable) {
                dispatch(extraProductActions.addPreOptInProduct(ancillary, true));
            }
        }
        else {
            dispatch(extraProductActions.removePreOptInProduct(ancillary));
        }
    });
};
export const metaPreOptedAncillariesFromCheckoutScreenQueryToApiQuery = () => {
    const screenQuery = new URLSearchParams(location.search);
    const apiQuery = new URLSearchParams();
    const products = [];
    if (screenQuery.get(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket)) {
        products.push("EXTRA.AIR_REBOOKING");
    }
    if (screenQuery.get(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.checkedInBaggage)) {
        products.push("EXTRA.BAGGAGE");
    }
    if (products.length > 0) {
        apiQuery.set("selectedProducts", products.join(","));
    }
    return apiQuery;
};
export const metaPreOptedAncillariesFromFlightDetailsScreenQueryToApiQuery = (screenQuery) => {
    const screenQueryParam = screenQuery.get("selectedProducts");
    const apiQuery = new URLSearchParams();
    if (screenQueryParam) {
        apiQuery.set("selectedProducts", screenQueryParam);
    }
    return apiQuery;
};
export const metaPreOptedAncillariesFromFlightToStore = (ancillaries, actions) => {
    actions.resetPreOptIn();
    const screenQuery = new URLSearchParams(location.search);
    const { flexibleTicket, checkedInBaggage } = ancillaries;
    if (flexibleTicket?.preSelected || screenQuery.get(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket)) {
        actions.addPreOptInProduct("flexibleTicket", true);
    }
    if (screenQuery.get(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason)) {
        actions.addPreOptInProduct("cancelForAnyReason", true);
    }
    const isCheckedInBaggageAvailableAndPreSelected = checkedInBaggage?.options;
    if (isCheckedInBaggageAvailableAndPreSelected) {
        isCheckedInBaggageAvailableAndPreSelected.forEach((option) => {
            option.preSelected && actions.addPreOptInProduct("checkedInBaggage", true);
        });
    }
};
export const preOptedAncillariesURLParams = (preOptedAncillaries) => {
    const preOptedParams = new URLSearchParams();
    for (const ancillary in preOptedAncillaries) {
        preOptedParams.set(ancillary, "true");
    }
    return preOptedParams;
};
